import Swiper from 'swiper';
import { Grid } from 'swiper/modules';

export default function setBannersLinha() {
  const sections = document.querySelectorAll('[data-banner-linha-carousel]');

  sections.forEach((section) => {
    const carousel = section.querySelector('.swiper');
    if (!carousel) return;

    new Swiper(carousel, {
      modules: [Grid],
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 0,
      watchOverflow: true,
      preloadImages: false,
      speed: 600,
      grid: {
        rows: 2,
        fill: 'row',
      },
      breakpoints: {
        992: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          grid: {
            rows: 1,
            fill: 'row',
          },
        },
      },
    });
  });
}
